import { Plants } from "@/types";

export const plants: Plants = {
  177: {
    localName: "Walnoot",
    type: "bomen",
    number: 177,
    name: "Juglans regia",
  },
  176: {
    localName: "Conifeer",
    type: "hagen",
    number: 176,
    name: "Cupressocyparis Leylandii",
  },
  175: {
    localName: "Leilinde",
    number: 175,
    type: "bomen",
    name: "Tilia Europaea",
  },
  174: {
    localName: "Sierappel",
    number: 174,
    type: "bomen",
    name: "Malus 'Golden Hornet'",
  },
  173: {
    type: "hagen",
    name: "Fagus Sylvatica",
    number: 173,
    localName: "Beuk",
  },
  53: {
    type: "heesters",
    name: "Photinia Fraseri 'Little Red Robin'",
    number: 53,
    localName: "Glansmispel",
  },
  65: {
    type: "heesters",
    name: "Perovskia Atriplicifolia Blue Spire",
    number: 65,
    localName: "Reuzenlavendel",
  },
  74: {
    type: "heesters",
    name: "Philadelphus Dame Blanche",
    number: 74,
    localName: "Boerenjasmijn",
  },
  114: {
    type: "heesters",
    name: "Spirea Japonica 'Little Princes'",
    number: 114,
    localName: "Spierstruik",
  },
  119: {
    type: "heesters",
    name: "Hamamelis Mollis Boskoop",
    number: 119,
    localName: "Toverhazelaar",
  },
  126: {
    type: "heesters",
    name: "Potentilla Fruticosa 'White Rain'",
    number: 126,
    localName: "Ganzerik",
  },
  131: {
    type: "heesters",
    name: "Photinia Fraseri 'Red Robin'",
    number: 131,
    localName: "Glansmispel",
  },
  141: {
    type: "heesters",
    name: "Spirea Japonica 'Gold Mound'",
    number: 141,
    localName: "Japanse Spirea",
  },
  143: {
    type: "heesters",
    name: "Prunus Laurocerasus 'Mount Vernon'",
    number: 143,
    localName: "Laurierkers",
  },
  145: {
    type: "heesters",
    name: "Sambucus Nigra Black Beauty",
    number: 145,
    localName: "Zwarte Vlier",
  },
  149: {
    type: "heesters",
    name: "Hamamelis Intermedea Diane",
    number: 149,
    localName: "Toverhazelaar",
  },
  151: {
    type: "heesters",
    name: "Spirea Cinerea 'Grefsheim'",
    number: 151,
    localName: "Spierstruik",
  },
  153: {
    type: "heesters",
    name: "Weigela 'Nana Variegata'",
    number: 153,
    localName: "Weigela",
  },
  154: {
    type: "heesters",
    name: "Spirea Japonica 'Genpei (Shirobama)'",
    number: 154,
    localName: "Spierstruik",
  },
  157: {
    type: "heesters",
    name: "Prunus Lauroceracus ‘Otto Luyken’",
    number: 157,
    localName: "Laurier",
  },
  14: {
    number: 14,
    type: "heesters",
    name: "Nandina Domestica",
    localName: "Hemelse Bamboe",
  },
  15: {
    number: 15,
    type: "heesters",
    name: "Olea Europaea",
    localName: "Olijfboom op stam",
  },
  22: {
    number: 22,
    type: "heesters",
    name: "Hydrangea Paniculata 'Limelight'",
    localName: "Pluimhortensia, Boerenhortensia",
  },
  31: {
    number: 31,
    type: "heesters",
    name: "Hypericum inodorum 'White Gem'",
    localName: "Hertshooi",
  },
  45: {
    number: 45,
    type: "heesters",
    name: "Viburnum bodnantense 'Dawn'",
    localName: "Sneeuwbal",
  },
  47: {
    number: 47,
    type: "heesters",
    name: "Chiosya Ternata",
    localName: "Chiosya",
  },
  52: {
    number: 52,
    type: "heesters",
    name: "Berberis thunbergii 'Atropurpurea Nana'",
    localName: "Zuurbes",
  },
  61: {
    number: 61,
    type: "heesters",
    name: "Clethra Alnifolia 'Hummingbird'",
    localName: "Schijnels",
  },
  64: {
    number: 64,
    type: "heesters",
    name: "Cercidiphyllum Japonicum",
    localName: "Katsura, Hartjesboom, Judasboom, Koekenboom",
  },
  68: {
    number: 68,
    type: "heesters",
    name: "Hydrangea Arborescens 'Strong Annabelle'",
    localName: "Hortensia",
  },
  69: {
    number: 69,
    type: "heesters",
    name: "Acer Palmatum 'Atropurpureum'",
    localName: "Japanse Esdoorn",
  },
  75: {
    number: 75,
    type: "heesters",
    name: "Hydrangea Macrophylla 'Bouquet Rose'",
    localName: "Tuinhortensia",
  },
  77: {
    number: 77,
    type: "heesters",
    name: "Cornus Florida F.Rubra",
    localName: "Kornoelje",
  },
  84: {
    number: 84,
    type: "heesters",
    name: "Cotinus Coggygria 'Royal Purple'",
    localName: "Pruikenboom",
  },
  88: {
    number: 88,
    type: "heesters",
    name: "Buddleja Davidii 'Adonis Blue'",
    localName: "Vlinderstruik",
  },
  89: {
    number: 89,
    type: "heesters",
    name: "Cornus Kousa 'China Girl'",
    localName: "Japanse Grootbloemige Kornoelje",
  },
  100: {
    number: 100,
    type: "heesters",
    name: "Magnolia Stellata",
    localName: "Stermagnolia",
  },
  101: {
    number: 101,
    type: "heesters",
    name: "Rosa the Fairy",
    localName: "Bodembedekkende Roos",
  },
  102: {
    number: 102,
    type: "heesters",
    name: "Cornus Sanguinea Winter Beauty",
    localName: "Rode Kornoelje",
  },
  104: {
    number: 104,
    type: "heesters",
    name: "Fothergilla Major",
    localName: "Lampenpoetserstruik",
  },
  110: {
    number: 110,
    type: "heesters",
    name: "Acer Palmatum 'Osakazuki'",
    localName: "Japanse Esdoorn",
  },
  111: {
    number: 111,
    type: "heesters",
    name: "Hydrangea Quercifolia",
    localName: "Eikenbladhortensia",
  },
  117: {
    number: 117,
    type: "heesters",
    name: "Hydrangea Serrata 'Bluebird'",
    localName: "Hortensia",
  },
  118: {
    number: 118,
    type: "heesters",
    name: "Hypericum Inodorum 'Red Gem'",
    localName: "Hertshooi",
  },
  120: {
    number: 120,
    type: "heesters",
    name: "Caryopteris Clandonesis 'Heavenly Blue'",
    localName: "Blauwbaard",
  },
  122: {
    number: 122,
    type: "heesters",
    name: "Viburnum Davidii",
    localName: "Sneeuwbal",
  },
  128: {
    number: 128,
    type: "heesters",
    name: "Acer Palmatum 'Disectum'",
    localName: "Japanse Esdoorn",
  },
  129: {
    number: 129,
    type: "heesters",
    name: "Salix Treurwilg",
  },
  133: {
    number: 133,
    type: "heesters",
    name: "Cornus Controversa",
    localName: "Reuzenkornoelje, Pagodekornoelje",
  },
  140: {
    number: 140,
    type: "heesters",
    name: "Viburnum Opulus",
    localName: "Gelderse roos",
  },
  142: {
    number: 142,
    type: "heesters",
    name: "Buddleja Davidii 'Black Knight'",
    localName: "Vlinderstruik",
  },
  144: {
    number: 144,
    type: "heesters",
    name: "Ribes Sanguineum",
    localName: "Rode sierbes, siertrosbes",
  },
  147: {
    number: 147,
    type: "heesters",
    name: "Hibiscus Syriacus 'Violet Clair Double'",
    localName: "Altheastruik",
  },
  148: {
    number: 148,
    type: "heesters",
    name: "Hydrangea Arborescens 'Annabelle'",
    localName: "Hortensia",
  },
  150: {
    number: 150,
    type: "heesters",
    name: "Diervilla Sessilifolia 'Butterfly'",
    localName: "Diervilla Sessilifolia",
  },
  159: {
    number: 159,
    type: "heesters",
    name: "Viburnum Bodnantense 'Charles Lamont'",
    localName: "Sneeuwbal",
  },
  161: {
    number: 161,
    type: "heesters",
    name: "Euonymus Fortunei 'Emerald Gaiety'",
    localName: "Bontbladige kardinaalsmuts",
  },
  167: {
    number: 167,
    type: "heesters",
    name: "Prunus Lusitanica",
    localName: "Portugese laurier",
  },
  2: {
    number: 2,
    name: "Persicaria Affinis 'Darjeeling Red'",
    localName: "Duizendknoop",
    type: "vaste planten",
  },
  5: {
    number: 5,
    name: "Lavandula angustifolia 'Hidcote'",
    localName: "Lavendel",
    type: "vaste planten",
  },
  6: {
    number: 6,
    name: "Ophiopogon Planiscapus 'Niger'",
    localName: "Slangebaard",
    type: "vaste planten",
  },
  9: {
    number: 9,
    name: "Ophiopogon Japonicus 'Minor'",
    localName: "Slangebaard",
    type: "vaste planten",
  },
  11: {
    number: 11,
    name: "Teucrium Chamaedrys",
    localName: "Echte Gamander",
    type: "vaste planten",
  },
  13: {
    number: 13,
    name: "Lamium Maculatum 'Pink Pewter'",
    localName: "Gevlekte dovenetel",
    type: "vaste planten",
  },
  17: {
    number: 17,
    name: "Polystichum Setiferum 'Congestum'",
    localName: "Zachte Naaldvaren",
    type: "vaste planten",
  },
  18: {
    number: 18,
    name: "Miscanthus Sinensis 'Kleine Siberspinne'",
    localName: "Prachtriet",
    type: "vaste planten",
  },
  21: {
    number: 21,
    name: "Liriope Muscari",
    localName: "Leliegras",
    type: "vaste planten",
  },
  23: {
    number: 23,
    name: "Nepeta Racemosa 'Grog'",
    localName: "Kattekruid",
    type: "vaste planten",
  },
  26: {
    number: 26,
    name: "Panicum Virgatum 'Rehbraun'",
    localName: "Vingergras, Pluimgierst",
    type: "vaste planten",
  },
  36: {
    number: 36,
    name: "Rodgersia Pinnata",
    localName: "Schout-bij-nacht, Kijkblad",
    type: "vaste planten",
  },
  42: {
    number: 42,
    name: "Kirengeshoma Palmata",
    localName: "Japanse Wasbloem",
    type: "vaste planten",
  },
  56: {
    number: 56,
    name: "Sedum Spectabile 'Stardust'",
    localName: "Hemelsleutel",
    type: "vaste planten",
  },
  57: {
    number: 57,
    name: "Molinia Caerulea Variegata",
    localName: "(Bont) Pijpestrootje",
    type: "vaste planten",
  },
  58: {
    number: 58,
    name: "Lavandula angustifolia 'Edelweiss'",
    localName: "Witte Lavendel",
    type: "vaste planten",
  },
  70: {
    number: 70,
    name: "Bergenia Cordifolia",
    localName: "Schoenlappersplant",
    type: "vaste planten",
  },
  72: {
    number: 72,
    name: "Euonymus Fortunei 'Emerald 'n Gold'",
    localName: "Kardinaalsmuts",
    type: "vaste planten",
  },
  81: {
    number: 81,
    name: "Molinia Caerulea Arundinacea 'Karl Foerster'",
    localName: "Pijpestrootje",
    type: "vaste planten",
  },
  87: {
    number: 87,
    name: "Lychnis Coronaria",
    localName: "Prikneus",
    type: "vaste planten",
  },
  90: {
    number: 90,
    name: "... 'Edelweis'",
    type: "vaste planten",
  },
  96: {
    number: 96,
    name: "Paeonia Lactiflora 'Karl Rosenfield'",
    localName: "Karmozijnrode Pioenroos",
    type: "vaste planten",
  },
  103: {
    number: 103,
    name: "Koeleria Glauca",
    localName: "Fakkelgras",
    type: "vaste planten",
  },
  107: {
    number: 107,
    name: "Sedum Spectabile 'Herbstfreude'",
    localName: "Hemelsleutel, vetkruid",
    type: "vaste planten",
  },
  109: {
    number: 109,
    name: "Pennisetum Alopecuroides",
    localName: "Lampenpoetsersgras",
    type: "vaste planten",
  },
  112: {
    number: 112,
    name: "Ligularia dentata Othello",
    localName: "Tongkruiskruid",
    type: "vaste planten",
  },
  125: {
    number: 125,
    name: "Nepeta 'Six Hills Giant'",
    localName: "Kattekruid",
    type: "vaste planten",
  },
  127: {
    number: 127,
    name: "Leptinella Squalida",
    localName: "Koperknoopje",
    type: "vaste planten",
  },
  136: {
    number: 136,
    name: "Pennisetum Alopecuroides 'Hameln'",
    localName: "Lampenpoetsergras",
    type: "vaste planten",
  },
  138: {
    number: 138,
    name: "Sedum Spectabile 'Brillant'",
    localName: "Vetkruid, Hemelsleutel",
    type: "vaste planten",
  },
  139: {
    number: 139,
    name: "Persicaria Amplexicaulis",
    localName: "Duizendknoop",
    type: "vaste planten",
  },
  146: {
    number: 146,
    name: "Tiarella Cordifolia",
    localName: "Schuimbloem, Perzische Muts",
    type: "vaste planten",
  },
  152: {
    number: 152,
    name: "Stachys Byzantina Silver carpet",
    localName: "Ezelsoor",
    type: "vaste planten",
  },
  155: {
    number: 155,
    name: "Asplenium Scolopendrium",
    localName: "Tongvaren",
    type: "vaste planten",
  },
  160: {
    number: 160,
    name: "Thalictrum Aquilegifolium",
    localName: "Akeleiruit, Ruit",
    type: "vaste planten",
  },
  162: {
    number: 162,
    name: "Stipa Gigantea",
    localName: "Straalhaver, Reuzenvedergras",
    type: "vaste planten",
  },
  163: {
    number: 163,
    name: "Panicum Virgatum 'Heavy Metal'",
    localName: "Vingergras, parelgierst",
    type: "vaste planten",
  },
  164: {
    number: 164,
    name: "Rudbeckia Fulgida 'Goldsturm'",
    localName: "Zonnehoed",
    type: "vaste planten",
  },
  165: {
    number: 165,
    name: "Salvia Nemorosa 'Ostfriesland'",
    localName: "Salie",
    type: "vaste planten",
  },
  166: {
    number: 166,
    name: "Pachysandra Terminalis 'Green Carpet'",
    localName: "Dikkemanskruid, schaduwkruid",
    type: "vaste planten",
  },
  201: {
    number: 201,
    name: "Lavandula angustifolia 'Munstead'",
    localName: "Lavendel",
    type: "vaste planten",
  },
  202: {
    number: 202,
    name: "Polypodium Vulgare",
    localName: "Gewone eikvaren",
    type: "vaste planten",
  },
  19: {
    number: 19,
    name: "Vinca Minor 'Alba'",
    localName: "Kleine Witte Maagdenpalm",
    type: "vaste planten",
  },
  24: {
    number: 24,
    name: "Waldsteinia Ternata",
    localName: "Gele Aardbei",
    type: "vaste planten",
  },
  73: {
    number: 73,
    name: "Veronica Spicata",
    localName: "Ereprijs",
    type: "vaste planten",
  },
  76: {
    number: 76,
    name: "Veronica Gentianoides 'Pallida'",
    localName: "Ereprijs, Gentiaan-ereprijs",
    type: "vaste planten",
  },
  86: {
    number: 86,
    name: "Tricyrtis Hirta",
    localName: "Paddelelie, Armeluisorchidee",
    type: "vaste planten",
  },
  94: {
    number: 94,
    name: "Vinca Minor 'Atropurpurea'",
    localName: "Kleine Maagdenpalm",
    type: "vaste planten",
  },
  158: {
    number: 158,
    name: "Verbascum Chaixii 'Album'",
    localName: "Witbloeiende Zwarte Toorts",
    type: "vaste planten",
  },
  200: {
    number: 200,
    name: "Verbena Bonariensis",
    localName: "IJzerhard",
    type: "vaste planten",
  },
  1: {
    name: "Agapanthus Africanus",
    number: 1,
    localName: "Afrikaanse Lelie",
    type: "vaste planten",
  },
  34: {
    name: "Asarum Europaeum",
    number: 34,
    localName: "Mansoor",
    type: "vaste planten",
  },
  7: {
    name: "Anemone Hybrida 'Honorine Jobert'",
    number: 7,
    localName: "Herfstanemoon",
    type: "vaste planten",
  },
  79: {
    name: "Anemone Hupehenis 'Splendens'",
    number: 79,
    localName: "Japanse Anemoon",
    type: "vaste planten",
  },
  30: {
    name: "Anemone Hybrida 'Queen Charlotte'",
    number: 30,
    localName: "Herfstanemoon",
    type: "vaste planten",
  },
  32: {
    name: "Astrantia Major",
    number: 32,
    localName: "Zeeuws Knopje",
    type: "vaste planten",
  },
  33: {
    name: "Astilbe 'Sprite'",
    number: 33,
    localName: "Pluimspirea, Prachtspirea",
    type: "vaste planten",
  },
  35: {
    name: "Aconitum Henryi 'Sparks Varienty'",
    number: 35,
    localName: "Monnikskap",
    type: "vaste planten",
  },
  43: {
    name: "Astilboides Tabularis",
    number: 43,
    localName: "Tafelblad",
    type: "vaste planten",
  },
  44: {
    name: "Eupatorium",
    number: 44,
    localName: "Koninginnekruid",
    type: "vaste planten",
  },
  80: {
    name: "Astilbe Chinensis 'Pumila'",
    number: 80,
    localName: "Pluimspirea, Prachtspirea",
    type: "vaste planten",
  },
  93: {
    name: "Aconitum Napellus",
    number: 93,
    localName: "Monnikskap",
    type: "vaste planten",
  },
  99: {
    name: "Ajuga reptans Atropurpurea",
    number: 99,
    localName: "Kruipend Zenegroen",
    type: "vaste planten",
  },
  105: {
    name: "Acaena Microphylla",
    number: 105,
    localName: "Stekelnootje",
    type: "vaste planten",
  },
  132: {
    name: "Alchemilla Mollis",
    number: 132,
    localName: "Fraaie Vrouwenmantel",
    type: "vaste planten",
  },
  169: {
    name: "Agastache Mexicana",
    number: 169,
    localName: "Dropplant",
    type: "vaste planten",
  },
  172: {
    name: "Astilbe Hybride 'Fanal'",
    number: 172,
    localName: "Pluimspirea, Prachtspirea",
    type: "vaste planten",
  },
  123: {
    type: "vaste planten",
    name: "Helianthemum Bronze Teppich",
    number: 123,
    localName: "Zonneroosje",
  },
  10: {
    type: "vaste planten",
    name: "Festuca Glauca",
    number: 10,
    localName: "Blauw Schapegras",
  },
  16: {
    type: "vaste planten",
    name: "Briza Media",
    number: 16,
    localName: "Trilgras, bevertjes",
  },
  20: {
    type: "vaste planten",
    name: "Cimicifuga Ramosa 'Atropurpurea'",
    number: 20,
    localName: "Zilverkaars",
  },
  25: {
    type: "vaste planten",
    name: "Galium odoratum Asperula",
    number: 25,
    localName: "Lieve Vrouwe Bedstro",
  },
  260: {
    type: "vaste planten",
    name: "Athyrium Nipponicum 'Metallicum'",
    number: 260,
    localName: "Wijfjesvaren",
  },
  29: {
    type: "vaste planten",
    name: "Carex Morrowii 'Variegata'",
    number: 29,
    localName: "Japanse Zegge",
  },
  38: {
    type: "vaste planten",
    name: "Campanula Garganica",
    number: 38,
    localName: "Klokjesbloem",
  },
  40: {
    type: "vaste planten",
    name: "Epimedium Youngianum 'Roseum'",
    number: 40,
    localName: "Elfenbloem",
  },
  41: {
    type: "vaste planten",
    name: "Brunnera Macrophylla",
    number: 41,
    localName: "Kaukasisch Vergeet-mij-nietje",
  },
  48: {
    type: "vaste planten",
    name: "Helleborus Argutifolius",
    number: 48,
    localName: "Nieskruid, Kerstroos",
  },
  49: {
    type: "vaste planten",
    name: "Campanula Poscharskyana",
    number: 49,
    localName: "Klokjesbloem",
  },
  50: {
    type: "vaste planten",
    name: "Echinacea Purpurea",
    number: 50,
    localName: "Zonnehoed",
  },
  51: {
    type: "vaste planten",
    name: "Eupatorium Rugosum 'Chocolate'",
    number: 51,
    localName: "Koninginnekruid",
  },
  60: {
    type: "vaste planten",
    name: "Gypsophila repens Rosea",
    number: 60,
    localName: "Gipskruid, Kruipend Gipskruid,",
  },
  62: {
    type: "vaste planten",
    name: "Calamintha Nepeta Nepeta",
    number: 62,
    localName: "Steentijm",
  },
  63: {
    type: "vaste planten",
    name: "Helleborus Orientalis",
    number: 63,
    localName: "Nieskruid",
  },
  66: {
    type: "vaste planten",
    name: "Filipendula Purpurea",
    number: 66,
    localName: "Spirea",
  },
  67: {
    type: "vaste planten",
    name: "Hosta Sieboldiana 'Elegans'",
    number: 67,
    localName: "Hartlelie",
  },
  78: {
    type: "vaste planten",
    name: "Epimedium Youngianum 'Niveum'",
    number: 78,
    localName: "Elfenbloem",
  },
  83: {
    type: "vaste planten",
    name: "Geranium Cantabrigiense Biokovo",
    number: 83,
    localName: "Ooivaarsbek",
  },
  85: {
    type: "vaste planten",
    name: "Echinops Bannaticus 'Taplow Blue'",
    number: 85,
    localName: "Kogeldistel",
  },
  91: {
    type: "vaste planten",
    name: "Ceratostigma Plumbaginoides",
    number: 91,
    localName: "Loodkruid",
  },
  92: {
    type: "vaste planten",
    name: "Campanula Lactiflora 'Loddon Anna'",
    number: 92,
    localName: "Klokjesbloem",
  },
  95: {
    type: "vaste planten",
    name: "Iberus Sempervirens",
    number: 95,
    localName: "Scheefbloem",
  },
  97: {
    type: "vaste planten",
    name: "Geranium 'Azure Rush'",
    number: 97,
    localName: "Ooivaarsbek",
  },
  98: {
    type: "vaste planten",
    name: "Imperata cylindrica 'Red baron'",
    number: 98,
    localName: "Japans bloedgras",
  },
  108: {
    type: "vaste planten",
    name: "Dicentra Spectabilis",
    number: 108,
    localName: "Gebroken hartje",
  },
  113: {
    type: "vaste planten",
    name: "Echinacea Purpurea 'White swan'",
    number: 113,
    localName: "Zonnehoed",
  },
  115: {
    type: "vaste planten",
    name: "Carex Ornithopoda 'Variegata'",
    number: 115,
    localName: "Zegge",
  },
  121: {
    type: "vaste planten",
    name: "Heuchera Micrantha Palace Purple",
    number: 121,
    localName: "Purperklokje",
  },
  124: {
    type: "vaste planten",
    name: "Iris Pumila Bright White",
    number: 124,
    localName: "Zwaardlelie",
  },
  130: {
    type: "vaste planten",
    name: "Darmera Peltata",
    number: 130,
    localName: "Schildblad",
  },
  134: {
    type: "vaste planten",
    name: "Dicentra Formosa",
    number: 134,
    localName: "Gebroken hartje",
  },
  137: {
    type: "vaste planten",
    name: "Cimicifuga Simplex 'White Pearl'",
    number: 137,
    localName: "Zilverkaars",
  },
  156: {
    type: "vaste planten",
    name: "Geranium Macrorrhizum 'Spessart'",
    number: 156,
    localName: "Ooivaarsbek",
  },
  168: {
    type: "vaste planten",
    name: "Calamagrostis Acutiflora 'Karl Foerster'",
    number: 168,
    localName: "Struisgras, Bosstruisgras",
  },
  170: {
    type: "vaste planten",
    name: "Iris Pumila Azurea",
    number: 170,
    localName: "Dwergiris",
  },
  171: {
    type: "vaste planten",
    name: "Helictotrichon Sempervirens",
    number: 171,
    localName: "Sierhaver",
  },
  400: {
    type: "vaste planten",
    name: "Delphinium Galahad",
    number: 400,
    localName: "Ridderspoor",
  },
  3: {
    name: "Campsis Radicans Flava",
    type: "klimplanten",
    number: 3,
    localName: "Gele trompetklimmer",
  },
  39: {
    name: "Parthenocissus Quinquefolia 'Engelmannii'",
    number: 39,
    type: "klimplanten",
    localName: "Wilde Wingerd",
  },
  59: {
    name: "Akebia Quinata",
    type: "klimplanten",
    number: 59,
    localName: "Klimbes, Schijnaugurk",
  },
  116: {
    name: "Clematis Montana Rubens",
    type: "klimplanten",
    number: 116,
    localName: "Bosrank, Bosdruif",
  },
  401: {
    name: "Rosa Paul's Scarlet Climber",
    type: "klimplanten",
    number: 401,
    localName: "Rode klimroos",
  },
  402: {
    name: "Klimroos Roze",
    type: "klimplanten",
    number: 402,
    localName: "Roze klimroos",
  },
  403: {
    name: "Klimroos Wit",
    type: "klimplanten",
    number: 403,
    localName: "Witte klimroos",
  },
  106: {
    name: "Arelea Elata",
    number: 106,
    type: "heesters",
    localName: "Duivelswandelstok, Engelenboom",
  },
  8: {
    name: "Trachelospermum Jasminoides",
    number: 8,
    type: "klimplanten",
    localName: "Toscaanse jasmijn, Sterjasmijn",
  },
  4: {
    name: "Ficus carica",
    number: 4,
    type: "heesters",
    localName: "Winterharde vijg",
  },
  27: {
    name: "Fagus sylvatica 'Atropurpurea'",
    number: 27,
    type: "bomen",
    localName: "Rode Beuk",
  },
  28: {
    name: "Camelia Japonica",
    number: 28,
    type: "heesters",
    localName: "Japanse roos",
  },
  37: {
    name: "Periploca Graeca",
    number: 37,
    type: "klimplanten",
    localName: "Melkwingerd",
  },
  205: {
    name: "Crataegus Monogyna",
    type: "hagen",
    localName: "Gewone meidoorn",
    number: 205,
  },
  207: {
    name: "Rhododendron",
    type: "heesters",
    localName: "Rhododendron",
    number: 207,
  },
  12: {
    name: "Crocosmia 'Lucifer'",
    type: "vaste planten",
    localName: "Montbretia",
    number: 12,
  },
  206: {
    name: "Acer platanoides 'Globosum'",
    type: "bomen",
    localName: "Bolesdoorn",
    number: 206,
  },
  55: {
    name: "Agastache 'black adder'",
    type: "vaste planten",
    localName: "Anijsnetel, Dropplant, Koreaanse Munt",
    number: 55,
  },
  71: {
    name: "Aster",
    type: "vaste planten",
    localName: "",
    number: 71,
    todo: true,
  },
  82: {
    name: "Varen",
    type: "vaste planten",
    todo: true,
    number: 82,
    localName: "Varen",
  },
  54: {
    name: "Geranium",
    type: "vaste planten",
    todo: true,
    number: 54,
    localName: "Geranium",
  },
  208: {
    name: "Rosa Gallica",
    localName: "Franse roos",
    todo: true,
    number: 208,
    type: "heesters",
  },
  209: {
    name: "Rosa",
    localName: "Roos",
    todo: true,
    number: 209,
    type: "heesters",
  },
};
